import React from 'react';
import { EditorProvider } from '../../editor/state';
import { LocaleProvider } from '../../locales';
import EditorLayout from './components/EditorLayout';
import { StandardColorInputBridge } from './components/form-controls/StandardColorPicker';
import './QuestionEditor.css';

const QuestionEditor: React.FC = () => (
  <LocaleProvider>
    <EditorProvider>
      <EditorLayout />
      {/* Öğe ayarlarındaki tüm native renk inputlarını standart palet
          popover'ına yönlendiren global köprü. */}
      <StandardColorInputBridge />
    </EditorProvider>
  </LocaleProvider>
);

export default QuestionEditor;
